import type { RouteConfig } from 'vue-router'
import type { WheelRoute } from '@/components/layout/main-header/connected/AdminWheelDropdown.interfaces'

export const isWheelRoute = (routeConfig: RouteConfig): routeConfig is WheelRoute => {
  return (
    typeof routeConfig.name === 'string' &&
    (typeof routeConfig.meta?.title === 'string' || typeof routeConfig.meta?.i18nTitle === 'string') &&
    typeof routeConfig.meta?.icon === 'string' &&
    typeof routeConfig.meta?.is_authorized === 'function'
  )
}
